import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { workflowRepository } from "motw_core/Repositories/WorkflowRepository";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import { AreYouSure } from "source/app/services/Shared/RenderSwal/RenderSwal";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { RPGIconWithText } from "source/app/services/Shared/RPGIconWithText/RPGIconWithText";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { DeleteNodeAsync } from "source/app/services/Workflows/ChangeData/DeleteNodesAsync";
import {
    DeleteSelectedWorkflowNodesAsync,
} from "source/app/services/Workflows/WorkflowSelection";
import * as styles from "./DeleteNode.css";

export function DeleteNode({
    rootNode,
    selectedNodeCount,
    compact = false,
}: {
    rootNode: IWorkflowNode;
    selectedNodeCount: number;
    compact?: boolean;
}) {
    const [parentNode, setParentNode] = React.useState<IWorkflowNode>(rootNode);

    React.useEffect(() => {
        WithAnimatedProgressBarAsync(
            () =>
                workflowRepository
                    .GetParentNodeAsync(ClientDataProvider, rootNode)
                    .then((node) => setParentNode(node!)),
            `DeleteNode_GetParentNodeAsync`
        );
    }, [rootNode]);

    if (parentNode?.viewchronological) {
        return null;
    }

    const isDeletingSelectedNodes = selectedNodeCount > 0;
    const deleteLabel = isDeletingSelectedNodes
        ? `Delete ${selectedNodeCount} selected`
        : `Delete`;
    const deleteNodes = async () => {
        if (isDeletingSelectedNodes) {
            AreYouSure(
                `Are you sure? ${selectedNodeCount} selected nodes will be deleted`,
                async () => await DeleteSelectedWorkflowNodesAsync()
            );
            return;
        }

        await WithAnimatedProgressBarAsync(async () => {
            await DeleteNodeAsync(rootNode);
        });
    };

    return (
        <Render
            id="DeleteNode"
            when={rootNode.id !== 0}
            withClasses={styles.container}
        >
            {compact ? (
                <IconWithText
                    iconSuffix={EGlyphicon.trash}
                    whenClicked={deleteNodes}
                    displayAsBlock={false}
                />
            ) : (
                <RPGIconWithText
                    icon={ERPGIcon.skull}
                    whenClicked={deleteNodes}
                >
                    {deleteLabel}
                </RPGIconWithText>
            )}
        </Render>
    );
}
